/**
 * Collection facets: mobile drawer + realtime AJAX filtering
 */
(function () {
  const sectionRoot = document.querySelector('.main-collection-section');
  if (!sectionRoot) return;

  const sectionId = sectionRoot.id.replace(/^shopify-section-/, '');
  const panel = document.getElementById('CollectionFacets');
  const backdrop = document.querySelector('[data-facets-close].facets-backdrop');
  const openBtn = document.querySelector('[data-facets-open]');
  const closeTriggers = document.querySelectorAll('[data-facets-close]');
  const gridWrap = sectionRoot.querySelector('[data-collection-products]');
  let priceTimer = null;
  let abortController = null;

  function openFacets() {
    if (!panel || !openBtn) return;
    panel.classList.add('is-open');
    panel.classList.remove('hidden-mobile');
    backdrop?.removeAttribute('hidden');
    backdrop?.classList.add('is-visible');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeFacets() {
    if (!panel || !openBtn) return;
    panel.classList.remove('is-open');
    if (window.matchMedia('(max-width: 1023px)').matches) {
      panel.classList.add('hidden-mobile');
    }
    backdrop?.classList.remove('is-visible');
    backdrop?.setAttribute('hidden', '');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (openBtn && panel) {
    openBtn.addEventListener('click', () => {
      if (panel.classList.contains('is-open')) closeFacets();
      else openFacets();
    });
    closeTriggers.forEach((trigger) => trigger.addEventListener('click', closeFacets));
    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        panel.classList.remove('is-open', 'hidden-mobile');
        backdrop?.classList.remove('is-visible');
        backdrop?.setAttribute('hidden', '');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  function buildParams() {
    const params = new URLSearchParams();
    const form = sectionRoot.querySelector('[data-facets-form]');
    if (form) {
      new FormData(form).forEach((value, key) => {
        if (value !== '' && value != null) params.append(key, value);
      });
    }
    const sortSelect = sectionRoot.querySelector('[data-sort-by]');
    if (sortSelect && sortSelect.value) {
      params.set('sort_by', sortSelect.value);
    }
    return params;
  }

  function setLoading(isLoading) {
    sectionRoot.classList.toggle('is-filtering', isLoading);
    if (gridWrap) gridWrap.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function replaceSectionHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextSection = doc.querySelector(`#shopify-section-${sectionId}`) || doc.querySelector('.main-collection-section');
    if (!nextSection) return false;

    const pairs = [
      ['[data-collection-products]', '[data-collection-products]'],
      ['[data-collection-facets]', '[data-collection-facets]'],
      ['[data-collection-toolbar]', '[data-collection-toolbar]'],
      ['[data-collection-header-meta]', '[data-collection-header-meta]'],
      ['[data-collection-products-header]', '[data-collection-products-header]'],
    ];

    pairs.forEach(([currentSel, nextSel]) => {
      const current = sectionRoot.querySelector(currentSel);
      const next = nextSection.querySelector(nextSel);
      if (current && next) current.innerHTML = next.innerHTML;
    });

    return true;
  }

  async function renderCollection(pushUrl) {
    const params = buildParams();
    const path = window.location.pathname;
    const search = params.toString();
    const nextUrl = search ? `${path}?${search}` : path;
    const fetchUrl = `${path}?section_id=${encodeURIComponent(sectionId)}${search ? `&${search}` : ''}`;

    if (abortController) abortController.abort();
    abortController = new AbortController();
    setLoading(true);

    try {
      const response = await fetch(fetchUrl, { signal: abortController.signal });
      if (!response.ok) throw new Error('Filter request failed');
      const html = await response.text();
      replaceSectionHtml(html);

      if (pushUrl !== false) {
        window.history.pushState({ collectionFilters: true }, '', nextUrl);
      }

      // Re-bind compare if present
      if (typeof window.Alverio !== 'undefined') {
        window.Alverio.publish?.('collection:filtered');
      }
    } catch (err) {
      if (err.name !== 'AbortError') {
        // Fallback: full navigation
        window.location.href = nextUrl;
      }
    } finally {
      setLoading(false);
    }
  }

  function onFilterChange() {
    renderCollection(true);
    if (window.matchMedia('(max-width: 1023px)').matches) {
      // Keep drawer open so users can refine further
    }
  }

  sectionRoot.addEventListener('change', (e) => {
    if (e.target.matches('[data-filter-input]')) {
      onFilterChange();
    }
    if (e.target.matches('[data-sort-by]')) {
      // sync all sort selects
      sectionRoot.querySelectorAll('[data-sort-by]').forEach((el) => {
        if (el !== e.target) el.value = e.target.value;
      });
      onFilterChange();
    }
  });

  sectionRoot.addEventListener('input', (e) => {
    if (!e.target.matches('[data-filter-price]')) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(onFilterChange, 450);
  });

  sectionRoot.addEventListener('keydown', (e) => {
    if (e.target.matches('[data-filter-price]') && e.key === 'Enter') {
      e.preventDefault();
      clearTimeout(priceTimer);
      onFilterChange();
    }
  });

  sectionRoot.addEventListener('submit', (e) => {
    if (e.target.matches('[data-facets-form]')) {
      e.preventDefault();
      onFilterChange();
    }
  });

  sectionRoot.addEventListener('click', (e) => {
    const clearLink = e.target.closest('[data-filter-clear]');
    if (!clearLink) return;
    e.preventDefault();
    const href = clearLink.getAttribute('href');
    if (!href) return;

    // Navigate via section render using clear URL params
    const url = new URL(href, window.location.origin);
    const params = url.searchParams;
    // Clear form then apply params from clear URL
    const form = sectionRoot.querySelector('[data-facets-form]');
    if (form) form.reset();
    form?.querySelectorAll('[data-filter-input]').forEach((input) => {
      input.checked = false;
    });
    form?.querySelectorAll('[data-filter-price]').forEach((input) => {
      input.value = '';
    });

    // Use the clear URL directly
    const fetchUrl = `${url.pathname}?section_id=${encodeURIComponent(sectionId)}${url.search ? `&${url.searchParams.toString()}` : ''}`;
    setLoading(true);
    fetch(fetchUrl)
      .then((r) => r.text())
      .then((html) => {
        replaceSectionHtml(html);
        window.history.pushState({ collectionFilters: true }, '', url.pathname + url.search);
      })
      .catch(() => {
        window.location.href = href;
      })
      .finally(() => setLoading(false));
  });

  window.addEventListener('popstate', () => {
    const params = new URLSearchParams(window.location.search);
    const fetchUrl = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}${params.toString() ? `&${params}` : ''}`;
    setLoading(true);
    fetch(fetchUrl)
      .then((r) => r.text())
      .then((html) => replaceSectionHtml(html))
      .catch(() => window.location.reload())
      .finally(() => setLoading(false));
  });
})();
